import { apiAthenas } from '@/services/api/apiAthenas'

export function partsDivisionTrigger({ demandId }: { demandId: string }) {
  return apiAthenas.post<string>(
    `/demands/${demandId}/upload-perimeter-success`
  )
}
